'use strict';

var _ = require('lodash');
var SnapshotDatesChartLegendController = function SnapshotDatesChartLegendController($scope, $rootScope, summaryDashboardLegendFilterService, pricingSummaryCommonsDataService) {
  $scope.metricsLabels = [{
    id: 'avg-fare-change',
    label: 'Avg Eff Fare Change',
    legendLabel: 'Avg Eff Fare Chg',
    gridLabel: 'Average Effective Fare Change',
    chartLabel: 'Average Effective Fare Change',
    tooltipLabel: 'Avg Eff Fare Change',
    metric: 'avgFareChange'
  }, {
    id: 'total-fare-change',
    label: 'Total Eff Fare Change',
    legendLabel: 'Total Eff Fare Chg',
    gridLabel: 'Total Effective Fare Change',
    chartLabel: 'Total Effective Fare Change',
    tooltipLabel: 'Total Eff Fare Change',
    metric: 'totalFareChange'
  }];
  $scope.directionItems = [createDirectionItem('OUTBOUND'), createDirectionItem('INBOUND')];
  $scope.selectedDirectionItem = createDirectionItem(summaryDashboardLegendFilterService.getSelectedDirection());
  function getFilterOptions(type) {
    return _.chain($scope.chartData).cloneDeep().map(type).flatten().uniq().compact().sort().value();
  }
  function areFiltersNotEmpty() {
    return !_.isEmpty($scope.selectedMarkets) && !_.isEmpty($scope.selectedPoses) && !_.isEmpty($scope.selectedCabins);
  }
  $scope.initLegendFilters = function () {
    $scope.selectedMarkets = null;
    $scope.selectedPoses = null;
    $scope.selectedCabins = null;
    $scope.populateLegendFilters().then(function () {
      $scope.$applyAsync(function () {
        $scope.selectedMarkets = _.cloneDeep($scope.comboboxMarkets);
        $scope.selectedPoses = _.cloneDeep($scope.comboboxPoses);
        $scope.selectedCabins = _.cloneDeep($scope.comboboxCabins);
        $scope.selectedMetric = _.first($scope.metricsLabels);
        $scope.selectedDirectionItem = _.first($scope.directionItems);
      }, 100);
    });
  };
  $scope.populateLegendFilters = function () {
    return pricingSummaryCommonsDataService.getSummaryMarkets().then(function (markets) {
      $scope.comboboxMarkets = markets;
      $scope.comboboxPoses = getFilterOptions('poses');
      $scope.comboboxCabins = getFilterOptions('cabins');
    });
  };
  $scope.resetChartHandler = function () {
    $scope.resetChart();
    $scope.selectedMarkets = null;
    $scope.selectedPoses = null;
    $scope.selectedCabins = null;
    $scope.selectedMarkets = _.cloneDeep($scope.comboboxMarkets);
    $scope.selectedPoses = _.cloneDeep($scope.comboboxPoses);
    $scope.selectedCabins = _.cloneDeep($scope.comboboxCabins);
    $scope.selectedDirectionItem = _.first($scope.directionItems);
  };
  $scope.changeMetrics = function (legendName, selectedLegend) {
    $rootScope.$broadcast('SnapshotDatesChart:changeLegend:metrics', selectedLegend);
  };
  $scope.$watch('selectedMarkets', function (markets) {
    summaryDashboardLegendFilterService.setSelectedMarkets(markets);
    if (areFiltersNotEmpty()) {
      $scope.reloadChart(null, true);
    }
  });
  $scope.$watch('selectedPoses', function (poses) {
    summaryDashboardLegendFilterService.setSelectedPoses(poses);
    if (areFiltersNotEmpty()) {
      $scope.reloadChart(null, true);
    }
  });
  $scope.$watch('selectedCabins', function (cabins) {
    summaryDashboardLegendFilterService.setSelectedCabins(cabins);
    if (areFiltersNotEmpty()) {
      $scope.reloadChart();
    }
  });
  $scope.$watch('selectedDirectionItem', function (direction) {
    summaryDashboardLegendFilterService.setSelectedDirection(direction.value);
    if (areFiltersNotEmpty()) {
      $scope.reloadChart();
    }
  });
  $scope.$watch('selectedMetric', function (selectedMetric) {
    if (selectedMetric && selectedMetric.id) {
      $scope.changeMetrics('metrics', selectedMetric);
    }
  });
  function createDirectionItem(directionValue) {
    var directionLabel = _.chain(directionValue).lowerCase().upperFirst().value();
    return {
      label: directionLabel,
      value: directionValue
    };
  }
};
SnapshotDatesChartLegendController.$inject = ['$scope', '$rootScope', 'SummaryDashboardLegendFilterService', 'PricingSummaryCommonsDataService'];
module.exports = SnapshotDatesChartLegendController;